// Generated by purs version 0.11.7
"use strict";
var Control_Semigroupoid = require("../Control.Semigroupoid");
var Data_Tuple = require("../Data.Tuple");
var Halogen_VDom_DOM_Prop = require("../Halogen.VDom.DOM.Prop");
var Prelude = require("../Prelude");
var PrestoDOM_Core = require("../PrestoDOM.Core");
var PrestoDOM_Types = require("../PrestoDOM.Types");
var prop = function (dictIsProp) {
    return function (v) {
        return function ($3) {
            return Halogen_VDom_DOM_Prop.Property.create(v)(PrestoDOM_Core.toPropValue(dictIsProp)($3));
        };
    };
};
var rotation = prop(PrestoDOM_Core.stringIsProp)("rotation");
var rotationX = prop(PrestoDOM_Core.stringIsProp)("rotationX");
var rotationY = prop(PrestoDOM_Core.stringIsProp)("rotationY");
var scaleType = prop(PrestoDOM_Core.stringIsProp)("scaleType");
var scaleX = prop(PrestoDOM_Core.stringIsProp)("scaleX");
var scaleY = prop(PrestoDOM_Core.stringIsProp)("scaleY");
var scrollBarX = prop(PrestoDOM_Core.stringIsProp)("scrollBarX");
var scrollBarY = prop(PrestoDOM_Core.stringIsProp)("scrollBarY");
var selectable = prop(PrestoDOM_Core.stringIsProp)("selectable");
var selectableItem = prop(PrestoDOM_Core.stringIsProp)("selectableItem");
var selected = prop(PrestoDOM_Core.stringIsProp)("selected");
var selectedTabIndicatorColor = prop(PrestoDOM_Core.stringIsProp)("selectedTabIndicatorColor");
var selectedTabIndicatorHeight = prop(PrestoDOM_Core.stringIsProp)("selectedTabIndicatorHeight");
var setDate = prop(PrestoDOM_Core.stringIsProp)("setDate");
var shadowLayer = prop(PrestoDOM_Core.stringIsProp)("shadowLayer");
var showDividers = prop(PrestoDOM_Core.stringIsProp)("showDividers");
var singleLine = prop(PrestoDOM_Core.stringIsProp)("singleLine");
var stroke = prop(PrestoDOM_Core.stringIsProp)("stroke");
var tabTextColors = prop(PrestoDOM_Core.stringIsProp)("tabTextColors");
var text = prop(PrestoDOM_Core.stringIsProp)("text");
var textAllCaps = prop(PrestoDOM_Core.stringIsProp)("textAllCaps");
var textFromHtml = prop(PrestoDOM_Core.stringIsProp)("textFromHtml");
var textIsSelectable = prop(PrestoDOM_Core.stringIsProp)("textIsSelectable");
var textSize = prop(PrestoDOM_Core.stringIsProp)("textSize");
var toast = prop(PrestoDOM_Core.stringIsProp)("toast");
var translationX = prop(PrestoDOM_Core.stringIsProp)("translationX");
var translationY = prop(PrestoDOM_Core.stringIsProp)("translationY");
var translationZ = prop(PrestoDOM_Core.stringIsProp)("translationZ");
var typeface = prop(PrestoDOM_Core.stringIsProp)("typeface");
var url = prop(PrestoDOM_Core.stringIsProp)("url");
var values = prop(PrestoDOM_Core.stringIsProp)("values");
var visibility = prop(PrestoDOM_Core.stringIsProp)("visibility");
var weight = prop(PrestoDOM_Core.stringIsProp)("weight");
var width = prop(PrestoDOM_Core.lengthIsProp)("width");
var progressColor = prop(PrestoDOM_Core.stringIsProp)("progressColor");
var pivotY = prop(PrestoDOM_Core.stringIsProp)("pivotY");
var pivotX = prop(PrestoDOM_Core.stringIsProp)("pivotX");
var padding = prop(PrestoDOM_Core.stringIsProp)("padding");
var orientation = prop(PrestoDOM_Core.stringIsProp)("orientation");
var name = prop(PrestoDOM_Core.stringIsProp)("name");
var minWidth = prop(PrestoDOM_Core.stringIsProp)("minWidth");
var minHeight = prop(PrestoDOM_Core.stringIsProp)("minHeight");
var minDate = prop(PrestoDOM_Core.stringIsProp)("minDate");
var maxWidth = prop(PrestoDOM_Core.stringIsProp)("maxWidth");
var maxSeek = prop(PrestoDOM_Core.stringIsProp)("maxSeek");
var maxLines = prop(PrestoDOM_Core.stringIsProp)("maxLines");
var maxDate = prop(PrestoDOM_Core.stringIsProp)("maxDate");
var marginStart = prop(PrestoDOM_Core.stringIsProp)("marginStart");
var marginEnd = prop(PrestoDOM_Core.stringIsProp)("marginEnd");
var margin = prop(PrestoDOM_Core.stringIsProp)("margin");
var letterSpacing = prop(PrestoDOM_Core.stringIsProp)("letterSpacing");
var layout_gravity = prop(PrestoDOM_Core.stringIsProp)("layout_gravity");
var layoutTransition = prop(PrestoDOM_Core.stringIsProp)("layoutTransition");
var inputTypeI = prop(PrestoDOM_Core.stringIsProp)("inputTypeI");
var inputType = prop(PrestoDOM_Core.stringIsProp)("inputType");
var imageUrl = prop(PrestoDOM_Core.stringIsProp)("imageUrl");
var id_ = prop(PrestoDOM_Core.stringIsProp)("id");
var hintColor = prop(PrestoDOM_Core.stringIsProp)("hintColor");
var hint = prop(PrestoDOM_Core.stringIsProp)("hint");
var height = prop(PrestoDOM_Core.lengthIsProp)("height");
var hardware = prop(PrestoDOM_Core.stringIsProp)("hardware");
var gravity = prop(PrestoDOM_Core.stringIsProp)("gravity");
var foreground = prop(PrestoDOM_Core.stringIsProp)("foreground");
var fontStyle = prop(PrestoDOM_Core.stringIsProp)("fontStyle");
var fontSize = prop(PrestoDOM_Core.stringIsProp)("fontSize");
var fontFamily = prop(PrestoDOM_Core.stringIsProp)("fontFamily");
var focusable = prop(PrestoDOM_Core.stringIsProp)("focusable");
var focusOut = prop(PrestoDOM_Core.stringIsProp)("focusOut");
var focus = prop(PrestoDOM_Core.stringIsProp)("focus");
var fillViewport = prop(PrestoDOM_Core.stringIsProp)("fillViewport");
var elevation = prop(PrestoDOM_Core.stringIsProp)("elevation");
var duration = prop(PrestoDOM_Core.stringIsProp)("duration");
var dividerDrawable = prop(PrestoDOM_Core.stringIsProp)("dividerDrawable");
var delay = prop(PrestoDOM_Core.stringIsProp)("delay");
var curve = prop(PrestoDOM_Core.stringIsProp)("curve");
var cornerRadius = prop(PrestoDOM_Core.stringIsProp)("cornerRadius");
var colorFilter = prop(PrestoDOM_Core.stringIsProp)("colorFilter");
var color = prop(PrestoDOM_Core.stringIsProp)("color");
var clipChildren = prop(PrestoDOM_Core.stringIsProp)("clipChildren");
var clickable = prop(PrestoDOM_Core.stringIsProp)("clickable");
var checked = prop(PrestoDOM_Core.stringIsProp)("checked");
var buttonTint = prop(PrestoDOM_Core.stringIsProp)("buttonTint");
var btnColor = prop(PrestoDOM_Core.stringIsProp)("btnColor");
var btnBackground = prop(PrestoDOM_Core.stringIsProp)("btnBackground");
var backgroundTint = prop(PrestoDOM_Core.stringIsProp)("backgroundTint");
var backgroundDrawable = prop(PrestoDOM_Core.stringIsProp)("backgroundDrawable");
var backgroundColor = prop(PrestoDOM_Core.stringIsProp)("backgroundColor");
var background = prop(PrestoDOM_Core.stringIsProp)("background");
var alpha = prop(PrestoDOM_Core.stringIsProp)("alpha");
var adjustViewBounds = prop(PrestoDOM_Core.stringIsProp)("adjustViewBounds");
var accessibilityHint = prop(PrestoDOM_Core.stringIsProp)("accessibilityHint");
var a_scaleY = prop(PrestoDOM_Core.stringIsProp)("a_scaleY");
var a_scaleX = prop(PrestoDOM_Core.stringIsProp)("a_scaleX");
var a_duration = prop(PrestoDOM_Core.stringIsProp)("a_duration");
module.exports = {
    prop: prop,
    name: name,
    id_: id_,
    textFromHtml: textFromHtml,
    showDividers: showDividers,
    dividerDrawable: dividerDrawable,
    tabTextColors: tabTextColors,
    selectedTabIndicatorHeight: selectedTabIndicatorHeight,
    foreground: foreground,
    selectedTabIndicatorColor: selectedTabIndicatorColor,
    layoutTransition: layoutTransition,
    focusOut: focusOut,
    focus: focus,
    fillViewport: fillViewport,
    setDate: setDate,
    minDate: minDate,
    maxDate: maxDate,
    clipChildren: clipChildren,
    adjustViewBounds: adjustViewBounds,
    maxLines: maxLines,
    singleLine: singleLine,
    hardware: hardware,
    selected: selected,
    curve: curve,
    fontFamily: fontFamily,
    checked: checked,
    backgroundDrawable: backgroundDrawable,
    buttonTint: buttonTint,
    visibility: visibility,
    scaleType: scaleType,
    progressColor: progressColor,
    alpha: alpha,
    imageUrl: imageUrl,
    url: url,
    translationY: translationY,
    translationX: translationX,
    translationZ: translationZ,
    delay: delay,
    duration: duration,
    pivotX: pivotX,
    pivotY: pivotY,
    minWidth: minWidth,
    minHeight: minHeight,
    maxWidth: maxWidth,
    letterSpacing: letterSpacing,
    hint: hint,
    inputType: inputType,
    inputTypeI: inputTypeI,
    textSize: textSize,
    fontSize: fontSize,
    textIsSelectable: textIsSelectable,
    fontStyle: fontStyle,
    textAllCaps: textAllCaps,
    toast: toast,
    scaleX: scaleX,
    scaleY: scaleY,
    a_scaleX: a_scaleX,
    a_scaleY: a_scaleY,
    a_duration: a_duration,
    gravity: gravity,
    orientation: orientation,
    text: text,
    width: width,
    weight: weight,
    height: height,
    layout_gravity: layout_gravity,
    margin: margin,
    marginStart: marginStart,
    marginEnd: marginEnd,
    padding: padding,
    cornerRadius: cornerRadius,
    stroke: stroke,
    typeface: typeface,
    background: background,
    backgroundColor: backgroundColor,
    color: color,
    hintColor: hintColor,
    btnBackground: btnBackground,
    colorFilter: colorFilter,
    btnColor: btnColor,
    shadowLayer: shadowLayer,
    elevation: elevation,
    rotationX: rotationX,
    rotationY: rotationY,
    rotation: rotation,
    backgroundTint: backgroundTint,
    scrollBarX: scrollBarX,
    scrollBarY: scrollBarY,
    clickable: clickable,
    focusable: focusable,
    selectable: selectable,
    selectableItem: selectableItem,
    values: values,
    maxSeek: maxSeek,
    accessibilityHint: accessibilityHint
};



//////////////////
// WEBPACK FOOTER
// ./output/PrestoDOM.Properties/index.js
// module id = 176
// module chunks = 0